@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

<form #form="ngForm" (keydown.enter)="$event.preventDefault()" novalidate>

  <!-- GENERAL INFO ACCORDION -->
  <div class="container-fluid accordion-container">
    <div class="container">
      <mat-accordion class="accordion" multi>
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="index">1</span>
              {{'generic.generic-info' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="row pt-3">
            <!-- Sidebar Profile Section -->
            <div class="col-12 col-md-4 mb-4">
              <div class="profile-card">
                <div class="profile-header">
                  @if (!modelUser?.details?.avatar_link) {
                    <img class="user-avatar" src="assets/img/user-placeholder.jpg" alt="User Avatar">
                  }
                  @if (modelUser?.details?.avatar_link) {
                    <img class="user-avatar" [src]="modelUser.details.avatar_link" alt="User Avatar">
                  }
                </div>

                <div class="profile-content">
                  @if (isLoggedUser) {
                    <div class="language-section">
                      <span class="label">{{'generic.language' | translate}}:</span>
                      <span class="value">{{userService.userDetails?.language}}</span>
                    </div>

                    <div class="language-actions">
                      @if (currentLang == 'it') {
                        <button mat-button color="primary" class="lang-btn" (click)="useLanguage('en')">
                          {{'components.header.component.change-language' | translate}}
                          <i class="icon-flag-en ml-2"><span class="path1"></span><span class="path2"></span><span
                          class="path3"></span><span class="path4"></span><span class="path5"></span><span
                          class="path6"></span><span class="path7"></span><span class="path8"></span><span
                          class="path9"></span><span class="path10"></span><span class="path11"></span><span
                        class="path12"></span></i>
                      </button>
                    }
                    @if (currentLang == 'en') {
                      <button mat-button color="primary" class="lang-btn" (click)="useLanguage('it')">
                        {{'components.header.component.change-language' | translate}}
                        <i class="icon-flag-it ml-2"><span class="path1"></span><span class="path2"></span><span
                      class="path3"></span></i>
                    </button>
                  }
                </div>

                <div class="action-buttons">
                  <button mat-button class="action-link" (click)="onClickChangePassword()">
                    {{ 'routing.title.change-password' | translate }}
                  </button>
                  <button mat-button class="action-link" (click)="onClickResetPassword()">
                    {{ 'routing.title.reset-password' | translate }}
                  </button>
                  <button matButton="filled" color="primary" class="upload-btn" (click)="onClickUploadPhoto()">
                    <mat-icon>cloud_upload</mat-icon>
                    {{'pages.user.single-user-management.component.upload-photo' | translate}}
                  </button>
                  <button mat-stroked-button color="primary" class="org-btn mt-2"
                    (click)="openDialogYourOrganizations()">
                    <fa-icon [icon]="faBuilding" class="mr-2"></fa-icon>
                    {{'pages.user.user-profile.component.your-organization' | translate}}
                  </button>
                </div>
              }

              @if (modelUser.id && modelUser.curricula) {
                <button mat-stroked-button color="accent" class="cv-btn w-100 mt-3"
                  [routerLink]="['curriculum/' + modelUser.curricula.id]">
                  <i class="icon-show mr-2"></i>
                  {{'pages.user.single-user-management.component.show-cv' | translate}}
                </button>
              }

              @if (modelUser.id) {
                <button mat-stroked-button color="primary" class="access-level-btn w-100 mt-3" (click)="showRoleAndPermission()">
                  <fa-icon [icon]="faLock" class="mr-2"></fa-icon>
                  {{'generic.access-level' | translate}}
                </button>
              }

              <!-- Admin Actions -->
              @if (canDeleteOrganizationUser() && !user.deleted_at && !isLoggedUser) {
                <button matButton="filled" color="warn" class="delete-btn w-100 mt-3" (click)="deleteOrganizationUser()">
                  <fa-icon [icon]="faTrash" class="mr-2"></fa-icon>
                  {{ "pages.user.single-user-management.component.delete-user" | translate }}
                </button>
              }
              @if (canDeleteOrganizationUser() && user.deleted_at && !isLoggedUser) {
                <button matButton="filled" class="restore-btn w-100 mt-3" (click)="resetOrganizationUser()">
                  <fa-icon [icon]="faTrashRestore" class="mr-2"></fa-icon>
                  {{'pages.user.all-users-management.component.undelete-user' | translate}}
                </button>
              }
            </div>
          </div>
        </div>

        <!-- Main Form Section -->
        <div class="col-12 col-md-8">
          <div class="form-card"> <!-- Removed mat-card to avoid double shadow inside accordion -->
            <div class="form-body">
              <div class="row">
                <div class="col-12 col-md-6 mb-3">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'generic.name' | translate}}</mat-label>
                    <input matInput required type="text" name="first_name" [(ngModel)]="modelUser.first_name">
                  </mat-form-field>
                </div>
                <div class="col-12 col-md-6 mb-3">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'generic.surname' | translate}}</mat-label>
                    <input matInput required type="text" name="last_name" [(ngModel)]="modelUser.last_name">
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-12 mb-3">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'generic.email' | translate}}</mat-label>
                    <input matInput type="email" name="email" [(ngModel)]="modelUser.email" required
                      [disabled]="modelUser.id ? true : false" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$">
                    @if (!modelUser.id) {
                      <mat-hint>
                        L'utente ricevrà su questa email una password generata automaticamente. Potrà cambiarla una
                        volta entrato.
                      </mat-hint>
                    }
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-12 mb-3">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'generic.secondary_email' | translate}}</mat-label>
                    <input matInput type="email" name="secondary_email" [(ngModel)]="modelUser.secondary_email"
                      pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$">
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-12 mb-3">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'generic.phone' | translate}}</mat-label>
                    <input matInput type="tel" minlength="10" name="phone" [(ngModel)]="modelUser.phone">
                  </mat-form-field>
                </div>
              </div>

              @if (isAlexion) {
                <div class="row">
                  <div class="col-12 mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>{{'swal.alexion.order-number.input-label' | translate}}</mat-label>
                      <input matInput type="text" name="order_number" [(ngModel)]="modelUser.order_number">
                      <mat-hint>{{'alexion.pages.user.single-user-management.component.order-number-description' |
                      translate}}</mat-hint>
                    </mat-form-field>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
</div>

<!-- DOCUMENTATION ACCORDION -->
@if (userAcceptedDocuments.length > 0 && isLoggedUser) {
  <div class="container-fluid accordion-container mt-4">
    <div class="container">
      <mat-accordion class="accordion" multi>
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="index">2</span>
              {{'generic.privacy-documents' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="doc-content pt-3">
            <div class="col-12 px-2 mb-4">
              <div class="mat-elevation-z8 table-container-rounded">
                <mat-table [dataSource]="dataSource" matSort class="table-primary table-no-stripe w-100">
              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef> {{ 'generic.name' | translate }} </mat-header-cell>
                <mat-cell *matCellDef="let row">
                  <span class="font-weight-bold text-dark">{{row.name}}</span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="version">
                <mat-header-cell *matHeaderCellDef> {{ 'generic.version' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.version || '1.0'}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="publication_date">
                <mat-header-cell *matHeaderCellDef> {{ 'generic.publication-date' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row"> {{ row.created_at | date:'dd/MM/yyyy'}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef class="justify-content-center pr-3">{{ 'generic.action' | translate
                }}</mat-header-cell>
                <mat-cell *matCellDef="let row" class="justify-content-end">
                  <button mat-button color="primary" [href]="row.link" target="_blank" class="mr-2">
                    {{ 'generic.view' | translate }}
                  </button>
                  @if (row.valid && row.to_accept) {
                    <button mat-button color="warn" (click)="revokeDocument(row.id)">
                      {{'generic.withdrawl' | translate}}
                    </button>
                  }
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
            <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
}
<div class="container buttons-container py-4 mt-4">
  @if (!isGuestUser) {
    <button type="button" class="button-primary float-left" mat-button [routerLink]="isUserCreation?['../../']:['../']"
      routerLinkActive="router-link-active">
      <i class="icon-Backward-arrow-small"></i>
      {{'generic.buttons.back' | translate}}
    </button>
  }
  @if (isGuestUser && userService.lastVisitedEvaluationIdQuestionnaire) {
    <button type="button" class="button-primary float-left" mat-button
      [routerLink]="['/responses/' + userService.lastVisitedEvaluationIdQuestionnaire + '/welcome/']"
      routerLinkActive="router-link-active">
      <i class="icon-Backward-arrow-small"></i>
      {{'generic.back-to-questionnaire' | translate}}
    </button>
  }
  <button type="button" class="button-primary float-right" mat-button [disabled]="loading || isGuestUser"
    (click)="onSubmit(form)">
    <i class="icon-Forward-arrow-small"></i>
    @if (!modelUser.id) {
      <span>{{'generic.buttons.save' | translate}}</span>
    }
    @if (modelUser.id) {
      <span>{{'generic.buttons.update' | translate}}</span>
    }
  </button>
</div>
</form>
